import React from "react";
import { withRouter } from "react-router-dom"
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import style from "./transactionResult.module.scss"
import Button from "../Button/button";

const TransactionResult = (props) => {
    return (
        <div className={style.wrapper}>
            <h1>شارژ کیف پول</h1>
            {
                props.success ?
                    <div className={style.content}>
                        <div className={style.icon}>f</div>
                        <p className={style.pBold}>.تراکنش با موفقیت انجام شد</p>
                        <p className={style.p}> شماره پیگیری: {toPersianNumber(props.data.trackId)}</p>
                        <div className={style.buttonWrapper}>
                            <Button label='ورود به صفحه داشبورد' type="solid" onclick={() => props.history.push('/')} />
                        </div>
                    </div>
                    :
                    <div className={style.content}>
                        <div className={style.failIcon}>g</div>
                        <p className={style.pBold}>تراکنش با خطا روبرو شد.</p>
                        <p className={style.p}>چنانچه مبلغی از حساب شما کسر شده است، تا ۲۴ ساعت آینده به حساب شما باز
                            خواهد گشت.</p>
                        <p className={style.p}> شماره تراکنش: {toPersianNumber(props.data.trackId)}</p>
                        <div className={style.row}>
                            <div className={style.buttonWrapper}>
                                <Button label='تلاش مجدد' type="solid"
                                    onclick={() => props.history.push('/chargewallet')} />
                            </div>
                            <div className={style.buttonWrapper}>
                                <Button label='بازگشت و مشاهده کیف پول' type="outline"
                                    onclick={() => props.history.push('/wallet')} />
                            </div>
                        </div>
                    </div>
            }
        </div>
    )
}
export default withRouter(TransactionResult);



